export default "float circularIn(float t) {\n  return 1.0 - sqrt(1.0 - t * t);\n}\n\n"